import { ResumeCardData } from 'src/models/resumeCard';

export const getCanMoveTopic = ({
    resume,
    isHiringManagerExp,
    isPfp,
    canCommunicateApplicant,
}: {
    resume: ResumeCardData;
    isPfp: boolean;
    isHiringManagerExp: boolean;
    canCommunicateApplicant: boolean;
}): boolean => {
    let canMoveTopic = true;
    if (isHiringManagerExp) {
        canMoveTopic = isPfp ? !!resume.canOpenContacts : canCommunicateApplicant;
    }

    return canMoveTopic;
};
